/**
 * Property Item Style enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum PROPERTY_ITEM_STYLE {
	SIMPLE = "simple",
	CHIP = "chip"
}

export const PROPERTY_ITEM_STYLE_default: keyof typeof PROPERTY_ITEM_STYLE = "SIMPLE";
